export const getUniqueRelatedIds = items => {
  return [...new Set(items.reduce((relatedIds, {
    asRelatedItemId
  }) => asRelatedItemId ? [...relatedIds, asRelatedItemId] : relatedIds, []))];
};